"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var EntryStateManager = /*#__PURE__*/function () {
  function EntryStateManager() {
    var _this = this;
    (0, _classCallCheck2["default"])(this, EntryStateManager);
    this.undoStack_ = [];
    this.redoStack_ = [];

    /** prevent add command when undo and redo */
    this.isRestore = false;
    this._isRedoing = false;
    this.isIgnore = false;
    Entry.addEventListener('cancelLastCommand', function (e) {
      _this.cancelLastCommand();
    });
    Entry.addEventListener('saveWorkspace', function (e) {
      _this.addStamp();
    });
    Entry.addEventListener('undo', function (e) {
      _this.undo();
    });
    Entry.addEventListener('redo', function (e) {
      _this.redo();
    });
  }
  return (0, _createClass2["default"])(EntryStateManager, [{
    key: "generateView",
    value: function generateView(stateManagerView, option) {
      console.warn('this method is nothing to do. please consider remove logic');
    }
  }, {
    key: "addCommand",
    value: function addCommand(type, caller, func, params) {
      if (this.isIgnoring()) {
        return;
      }
      var state = new Entry.State();
      Entry.State.prototype.constructor.apply(state, Array.prototype.slice.call(arguments));
      if (this.isRestoring()) {
        this.redoStack_.push(state);
      } else {
        this.undoStack_.push(state);
        if (!this._isRedoing) {
          this.redoStack_ = [];
        }
      }
      if (Entry.reporter) {
        Entry.reporter.report(state);
      }
      if (Entry.creationChangedEvent) {
        Entry.creationChangedEvent.notify();
      }
      return state;
    }
  }, {
    key: "cancelLastCommand",
    value: function cancelLastCommand() {
      if (!this.canUndo()) {
        return;
      }
      this.undoStack_.pop();
      if (Entry.creationChangedEvent) {
        Entry.creationChangedEvent.notify();
      }
    }
  }, {
    key: "getLastCommand",
    value: function getLastCommand() {
      return this.undoStack_[this.undoStack_.length - 1];
    }
  }, {
    key: "getLastCommandById",
    value: function getLastCommandById(id) {
      var undoStack = this.undoStack_;
      var len = undoStack.length - 1;
      for (var i = len; i >= 0; i--) {
        var state = undoStack[i];
        if (state.id === id) {
          return state;
        }
      }
    }
  }, {
    key: "getLastRedoCommand",
    value: function getLastRedoCommand() {
      return this.redoStack_[this.redoStack_.length - 1];
    }
  }, {
    key: "removeAllPictureCommand",
    value: function removeAllPictureCommand() {
      this.undoStack_ = this.undoStack_.filter(function (stack) {
        return !(stack.message >= 400 && stack.message < 500);
      });
      this.redoStack_ = this.redoStack_.filter(function (stack) {
        return !(stack.message >= 400 && stack.message < 500);
      });
    }
  }, {
    key: "undo",
    value: function undo(count) {
      if (!this.canUndo() || this.isRestoring()) {
        return;
      }
      this.addActivity('undo');
      this.startRestore();
      var isFirst = true;
      while (this.undoStack_.length) {
        var state = this.undoStack_.pop();
        state.func.apply(state.caller, state.params);
        var command = this.getLastRedoCommand();
        if (isFirst) {
          command.isPass = false;
          isFirst = !isFirst;
        } else {
          command.isPass = true;
        }
        if (count) {
          count--;
        }
        if (!count && state.isPass !== true) {
          break;
        }
      }
      this.endRestore();
      if (Entry.disposeEvent) {
        Entry.disposeEvent.notify();
      }
      if (Entry.creationChangedEvent) {
        Entry.creationChangedEvent.notify();
      }
    }
  }, {
    key: "redo",
    value: function redo() {
      if (!this.canRedo() || this.isRestoring()) {
        return;
      }
      this._isRedoing = true;
      this.addActivity('undo');
      this.addActivity('redo');
      var isFirst = true;
      while (this.redoStack_.length) {
        var state = this.redoStack_.pop();
        var ret = state.func.apply(state.caller, state.params);
        if (isFirst) {
          ret.isPass(false);
          isFirst = !isFirst;
        } else {
          ret.isPass(true);
        }
        if (state.isPass !== true) {
          break;
        }
      }
      this._isRedoing = false;
      if (Entry.creationChangedEvent) {
        Entry.creationChangedEvent.notify();
      }
    }
  }, {
    key: "updateView",
    value: function updateView() {
      return;
      if (this.undoButton && this.redoButton) {
        if (this.canUndo()) {
          this.undoButton.addClass('active');
        } else {
          this.undoButton.removeClass('active');
        }
        if (this.canRedo()) {
          this.redoButton.addClass('active');
        } else {
          this.redoButton.removeClass('active');
        }
      }
    }
  }, {
    key: "startRestore",
    value: function startRestore() {
      this.isRestore = true;
    }
  }, {
    key: "endRestore",
    value: function endRestore() {
      this.isRestore = false;
    }
  }, {
    key: "isRestoring",
    value: function isRestoring() {
      return this.isRestore;
    }
  }, {
    key: "startIgnore",
    value: function startIgnore() {
      this.isIgnore = true;
    }
  }, {
    key: "endIgnore",
    value: function endIgnore() {
      this.isIgnore = false;
    }
  }, {
    key: "isIgnoring",
    value: function isIgnoring() {
      return this.isIgnore;
    }
  }, {
    key: "canUndo",
    value: function canUndo() {
      return this.undoStack_.length > 0 && Entry.engine.isState('stop');
    }
  }, {
    key: "canRedo",
    value: function canRedo() {
      return this.redoStack_.length > 0 && Entry.engine.isState('stop');
    }

    /**
     * mark state which one saved
     */
  }, {
    key: "addStamp",
    value: function addStamp() {
      this.stamp = Entry.generateHash();
      if (this.undoStack_.length) {
        this.undoStack_[this.undoStack_.length - 1].stamp = this.stamp;
      }
    }

    /**
     * @return {!boolean} return true when project is up-to-date
     */
  }, {
    key: "isSaved",
    value: function isSaved() {
      return this.undoStack_.length === 0 || this.undoStack_[this.undoStack_.length - 1].stamp == this.stamp && typeof this.stamp == 'string';
    }

    /**
     * @param {String} activityType
     */
  }, {
    key: "addActivity",
    value: function addActivity(activityType) {
      if (Entry.reporter) {
        Entry.reporter.report(new Entry.State(activityType));
      }
    }
  }, {
    key: "getUndoStack",
    value: function getUndoStack() {
      return this.undoStack_.slice(0);
    }
  }, {
    key: "changeLastCommandType",
    value: function changeLastCommandType(type) {
      var cmd = this.getLastCommand();
      if (cmd) {
        cmd.message = type;
      }
      return cmd;
    }
  }, {
    key: "clear",
    value: function clear() {
      while (this.undoStack_.length) {
        this.undoStack_.pop();
      }
      while (this.redoStack_.length) {
        this.redoStack_.pop();
      }
      if (Entry.creationChangedEvent) {
        Entry.creationChangedEvent.notify();
      }
    }
  }]);
}();
Entry.StateManager = EntryStateManager;